import { render, staticRenderFns } from "./questionResult.vue?vue&type=template&id=14bfd620&scoped=true&"
import script from "./questionResult.vue?vue&type=script&lang=js&"
export * from "./questionResult.vue?vue&type=script&lang=js&"
import style0 from "./questionResult.vue?vue&type=style&index=0&id=14bfd620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bfd620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14bfd620')) {
      api.createRecord('14bfd620', component.options)
    } else {
      api.reload('14bfd620', component.options)
    }
    module.hot.accept("./questionResult.vue?vue&type=template&id=14bfd620&scoped=true&", function () {
      api.rerender('14bfd620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/surveyQquestionnaire/components/questionResult.vue"
export default component.exports